import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';
import { MidstockPostState } from 'common-ts/dist/models/Midstock';
import { fetchClothInventory, fetchMidstockList } from "./MidstockListPostRedux";

const initialState: MidstockPostState = {
    midstockDraft: {
        midstockId: '',
        reorderTriggerAmount: 0,
    },

    dialogOpen: false,

    status: APIRequestStatus.Idle,
    error: ''
}

const slice = createSlice({
    name: 'midstockCreate',
    initialState,
    reducers: {
        updateVal(state, action) {
          state.midstockDraft = action.payload;
          console.log(`State values: ${JSON.stringify(state.midstockDraft)}`);
        },
        updateDialogOpen(state, action) {
          state.dialogOpen = action.payload;
        }
    },
    extraReducers(builder) {
        builder
          .addCase(postNewMidstock.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postNewMidstock.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postNewMidstock.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
          .addCase(postNewClothInventory.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postNewClothInventory.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postNewClothInventory.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
      }
})

export const postNewMidstock = createAsyncThunk('midstockCreate/postNewMidstock', async (arg, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock',
      data: state.midstockCreate.midstockDraft,
    });

    thunkAPI.dispatch(fetchMidstockList());

    return response.data
})

function dataURItoBlob(dataURI) {
  var binary = atob(dataURI.split(',')[1]);
  var array = [];
  for(var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
}

export const postNewClothInventory = createAsyncThunk('midstockCreate/postNewClothInventory', async (arg: {
  fileContent: any,
  contents: any,
}, thunkAPI) => {

    var currentFileDraft: any = {};
    currentFileDraft.fileName = "bahan-photo-" + arg.contents.clothInventoryId + ".jpg"; // Remove whitespace
    currentFileDraft.fileDataType = 'image/jpeg';
    currentFileDraft.fileCategory = 'general';
  
    const signedURLResponse = await axios({
      method: 'post',
      url: 'https://w3q706jlua.execute-api.ap-southeast-1.amazonaws.com/FileSystemAPIProduction/signedurl',
      data: currentFileDraft
    })
    
    console.log(signedURLResponse);
    const uploadURL = signedURLResponse.data.uploadURL;
    const createdFileKey = signedURLResponse.data.fileKey;
  
    try {
      const uploadResult = await axios({
        method: 'put',
        url: uploadURL,
        data: dataURItoBlob(arg.fileContent),
        headers: {
          "Content-Type": currentFileDraft.fileDataType,
        }
      })
  
      console.log("upload to s3 success:");
      console.log(uploadResult.headers);
      console.log(uploadResult.statusText);
      console.log(uploadResult);
    } catch (err) {
      console.log("Error uploading to s3:");
      console.log(err);
    }
    
    console.log("continue...")
    const fileURL = uploadURL.split('?')[0]

    const response = await axios({
      method: 'post',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock',
      data: {
        photoUrl: fileURL,
        ...arg.contents
      },
    });

    thunkAPI.dispatch(fetchClothInventory());

    return response.data
})

export const { updateVal, updateDialogOpen } = slice.actions

export default slice.reducer